"use client";

import { Modal, VideoPlayer } from "@pamperedchef/design-system";
import * as styles from "./VideoModal.module.scss";

export interface VideoModalProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	videoUrl?: string;
	poster?: string;
}

/**
 * Controlled modal that plays a video — DS `Modal` (size `xl`) wrapping the DS
 * `VideoPlayer`. No autoplay. When `videoUrl` is absent the modal still opens
 * with an empty player frame (per AC). Controlled via `open` + `onClose`,
 * mirroring `composites/foundation/ImageGalleryModal`.
 */
export function VideoModal({
	open,
	onClose,
	title,
	videoUrl,
	poster
}: VideoModalProps) {
	return (
		<Modal
			size="xl"
			title={title ?? ""}
			isOpen={open}
			setOpen={(value) => {
				const resolved =
					typeof value === "function" ? value(open) : value;
				if (!resolved) onClose();
			}}
			closeButtonLabel="Close video"
		>
			<div className={styles["video-modal__body"]}>
				{videoUrl ? (
					<VideoPlayer
						videoSrc={videoUrl}
						posterSrc={poster}
						controls
						containerClassName={styles["video-modal__player"]}
						videoClassName={styles["video-modal__video"]}
					/>
				) : (
					<div
						className={styles["video-modal__empty"]}
						aria-hidden="true"
					/>
				)}
			</div>
		</Modal>
	);
}
